export const config = {
  title: "A Star National Realty",
  meta: {
    description:
      "A Star National Realty, led by Realtor Linda Morson, provides expert real estate services in Detroit, MI and surrounding areas—offering home buying, selling, evaluation and market guidance.",
    keywords: [
      "Detroit real estate",
      "Linda Morson Realtor",
      "A Star National Realty",
      "homes for sale Detroit",
      "Detroit property evaluation"
    ],
    author: "A Star National Realty",
    canonicalUrl: "https://www.signwithlynn.com/",
  },
  sections: {
    header: { businessName: "A Star National Realty" },
    sectionB: {
      heroTitle: "A Star National Realty",
      heroSubtitle: "Detroit’s Trusted Real Estate Experts",
      learnAboutText: "Search Homes",
      phoneNumber: "3139745938",
      phoneLabel: "(313) 974‑5938",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2148582338/photo/new-residential-estate-houses-in-england.jpg?s=612x612&w=0&k=20&c=72q8EMez6A_uYP5bmQff-uuNYwkcNgIP_VxChq0k9ow=",
      cardData: [
        {
          title: "Home Buying",
          description:
            "Personalized guidance to find your ideal home in Detroit and beyond.",
        },
        {
          title: "Home Selling",
          description:
            "Professional listing, staging advice and negotiation for sellers.",
        },
        {
          title: "Free Evaluations",
          description:
            "No-cost home evaluations and market insights tailored to your needs.",
        },
      ],
      description:
        "Led by Realtor Linda Morson, A Star National Realty helps buyers and sellers in Detroit, Livonia, Redford, and nearby communities with expert support and market knowledge.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Full-service real estate support for buying, selling, and evaluating residential properties.",
      cards: [
        {
          title: "Home Buying",
          description:
            "Find homes matching your needs across Detroit Metro.",
          imageSrc: "https://media.istockphoto.com/id/1326353127/photo/estate-agent-showround.jpg?s=612x612&w=0&k=20&c=R7fB1IKc1QoscHbWe3QAEYYLrJOJqVPD4SUvNh5_s0g=",
          imageAlt: "Home Buying",
        },
        {
          title: "Home Selling",
          description:
            "Strategic marketing and negotiation to maximize your sale.",
          imageSrc: "https://media.istockphoto.com/id/2157419649/photo/beautiful-family-searching-for-their-new-home.jpg?s=612x612&w=0&k=20&c=KrxMycUM6JecYTPzgr6yVpTSwA6suC39E9ok2VHOBZ0=",
          imageAlt: "Home Selling",
        },
        {
          title: "Free Appraisal & Consulting",
          description:
            "Accurate home valuations and market trend analysis.",
          imageSrc: "https://media.istockphoto.com/id/2218211511/photo/professional-asian-female-agent-and-businessman-reviewing-property-plans-at-modern-kitchen.jpg?s=612x612&w=0&k=20&c=OPwW-hCwNzZxG0xUunx4BxWQ-rA9KVoxJLwORXjYL6k=",
          imageAlt: "Consulting",
        },
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "First-time buyer support",
        "Investment property guidance",
        "Relocation assistance",
        "Community market reports",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/26/2405426_normal.jpg",
        alt: "Realtor Linda Morson",
      },
      aboutText: [
        "Realtor Linda Morson at A Star National Realty helps clients with home buying, selling, and evaluations across Detroit and nearby areas.",
        "With a focus on professionalism, transparency, and personalized service, Lynn assists clients with market insights and effective negotiation.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "A Star National Realty Logo",
      businessName: "A Star National Realty",
      contact: {
        phone: "3139745938",
        phoneLabel: "(313) 974‑5938",
        email: "signwithlynn@gmail.com",
        website: "https://www.signwithlynn.com/",
        address: "19354 James Couzens Fwy, Detroit, MI 48235",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "19354 James Couzens Fwy, Detroit, MI 48235",
      googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2897.204130043666!2d-83.19218!3d42.43653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824ca0ee1234567%3A0x1234567890abcdef!2s19354%20James%20Couzens%20Fwy%2C%20Detroit%2C%20MI%2048235%2C%20USA!5e0!3m2!1sen!2sus!4v1737907200000!5m2!1sen!2sus",

    }
  },
};
export default config;
